import { Grid } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import JoditEditor from 'jodit-react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';


const BaseEditor = ({name}) => {

    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);


    const config = useMemo(
        () => ({
            readonly: false,
        }),
        []
    );

    const handleSubmit = () => {

        if (editor.current) {

            const content = editor.current.value;

            const uniqueId = uuidv4();

            const newPayload = 
                {
                    id: uniqueId,
                    name: name,
                    content: content
                }
            ;



            axios.post('/your-content-upload-endpoint', newPayload)
                .then(response => {
                    // console.log('Content successfully uploaded:', response.data);
                })
                .catch(error => {
                    // console.error('Error uploading content:', error);
                });
        }
    };




    useEffect(() => {

        handleSubmit()

    }, [editor.current])


    useEffect(() => {
        const initialContent = '';
        setContent(initialContent);
        setLoading(false);
    }, []);



    useEffect(() => {
        if (content) {
            setLoading(false);
        }
        if (editor.current) {
            editor.current.value = content;
        }
    }, [ content]);



    return (

        <Grid>
            <JoditEditor
                ref={editor}
                value={content}
                config={config}
                tabIndex={1} // tabIndex of textarea
                onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                onChange={(newContent) => setContent(newContent)}
            />
        </Grid>
    )
}

export default BaseEditor
